import React, { Component } from 'react'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { getAgeLimit } from '../constants';
import { checkCountryFromSSN } from '../views/patients/helper';

function calculateAgeFromDate(date) {
    const currentDate = new Date();
    let birthDate = new Date(date);
    birthDate.setHours(0, 0, 0, 0)
    // Get the year, month, and day from the current date
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();
    // Get the year, month, and day from the birth date
    const birthYear = birthDate.getFullYear();
    const birthMonth = birthDate.getMonth();
    const birthDay = birthDate.getDate();
    // Calculate the age
    let age = currentYear - birthYear;
    // Adjust the age if the birth month is after the current month,
    // or if the birth month is the same as the current month but the birth day is after the current day
    if (birthMonth > currentMonth || (birthMonth === currentMonth && birthDay > currentDay)) {
        age--;
    }

    return age;
}

const isStringAValidNumber = (string) => {
    if (typeof string !== 'string') return false;
    return !isNaN(string) && !isNaN(parseFloat(string));
};

function calculateAgeFromSSN(ssn, country) {
    if (country === 'denmark' || country === 'sweden') {
        let checkCountry;
        if (country === 'denmark' && ssn?.length === 12) {
            checkCountry = checkCountryFromSSN(ssn);
        } else if (country === 'sweden' && ssn?.length === 10) {
            checkCountry = checkCountryFromSSN(ssn);
        }
        if (checkCountry) {
            country = checkCountry;
        }
    }
    if (!country) {
        if (typeof window !== 'undefined' && localStorage && localStorage?.getItem?.('country')) country = localStorage?.getItem?.('country');
        else country = 'sweden';
    };

    if (!ssn || !isStringAValidNumber(ssn)) return null;

    let day;
    let month;
    let year;

    if (country === 'denmark') {
        if (ssn.length < 6) return null;
        day = Number(`${ssn[0]}${ssn[1]}`);
        month = Number(`${ssn[2]}${ssn[3]}`);
        const yearLastDigits = Number(`${ssn[4]}${ssn[5]}`);
        const nowYear = new Date().getFullYear();
        const nowYearLastDigits = `${String(nowYear)[2]}${String(nowYear)[3]}`;
        if (yearLastDigits === 0) year = 2000;
        else {
            if (yearLastDigits > +nowYearLastDigits) year = Number(`19${yearLastDigits < 10 ? '0' + yearLastDigits : yearLastDigits}`);
            else year = Number(`20${yearLastDigits < 10 ? '0' + yearLastDigits : yearLastDigits}`);
        }
    } else if (country === 'sweden') {
        if (ssn.length < 8) return null;
        year = parseInt(`${ssn[0]}${ssn[1]}${ssn[2]}${ssn[3]}`);
        month = parseInt(`${ssn[4]}${ssn[5]}`);
        day = parseInt(`${ssn[6]}${ssn[7]}`);
    }
    // Other countries

    if (day && month && year) {
        // let date = new Date(year, month - 1, day);
        // let years = (new Date().getTime() / 1000 - date.getTime() / 1000) / 31556926;
        // return years;
        const currentDate = new Date();
        const birthDate = new Date(year, month - 1, day);
        birthDate.setHours(0, 0, 0, 0);

        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();

        const birthYear = birthDate.getFullYear();
        const birthMonth = birthDate.getMonth();
        const birthDay = birthDate.getDate();

        let age = currentYear - birthYear;

        if (birthMonth > currentMonth || (birthMonth === currentMonth && birthDay > currentDay)) {
            age--;
        }

        return age;
    };

    return null;
}

export class AgeLimitErrorModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ageLimitError: false,
        }
    }

    navigateBackToProfile = () => {
        this.setState({ ageLimitError: false }, () => {
            if (typeof window !== 'undefined') {
                localStorage?.removeItem?.('groupAlias');
                // localStorage?.removeItem?.('lastGroup');
            }
            this.props?.[0]?.history?.replace?.('/my-data/account');
        });
    }

    checkUserAge = () => {
        if (this.props.uData) {
            let age;
            const dob = this.props.uData?.dateOfBirth?.date;
            if (dob) age = calculateAgeFromDate(dob);

            if ((!age && age !== 0) && this.props.uData?.socialSecurityNumber) age = calculateAgeFromSSN(this.props.uData?.socialSecurityNumber, this.props.country);

            // console.log('age', age);

            if (age) {
                const alias = this.props.clinicAlias ? this.props.clinicAlias : this.props[0]?.match?.params?.alias ? this.props[0]?.match?.params?.alias : null;
                const ageLimit = getAgeLimit(this.props.country, alias, this.props.clinicsAgeLimitExceptions);

                // console.log('ageLimit', ageLimit);

                if (age < ageLimit) this.setState({ ageLimitError: true });
            }
        }
    }

    componentDidMount() {
        this.checkUserAge();
    }

    componentDidUpdate(prevProps) {
        if (this.props.uData && (prevProps?.uData?._id !== this.props.uData?._id)) this.checkUserAge();

        if (prevProps?.country !== this.props.country) this.checkUserAge();

        const prevAlias = prevProps.clinicAlias ? prevProps.clinicAlias : prevProps[0]?.match?.params?.alias ? prevProps[0]?.match?.params?.alias : null;
        const alias = this.props.clinicAlias ? this.props.clinicAlias : this.props[0]?.match?.params?.alias ? this.props[0]?.match?.params?.alias : null;
        if (alias && prevAlias !== alias) this.checkUserAge();
    }

    render() {
        if (!this.state.ageLimitError) return null;

        return (
            <Modal
                zIndex={99999}
                size='md'
                centered
                isOpen={this.state.ageLimitError}
            >
                <ModalBody style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <p style={{ textAlign: 'center', margin: 0, padding: 0, }}>{'You are too young to access this clinic directly. Please submit your case through your parent/guardian.'.translate(this.props.lang)}</p>
                </ModalBody>
                <ModalFooter style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button onClick={this.navigateBackToProfile} style={{ minWidth: 100 }}>
                        {'Ok'.translate(this.props.lang)}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AgeLimitErrorModal